export default __webpack_public_path__ + "static/media/menu_policy_overview_icon.d43e4a40.svg";